import { Component, AfterViewInit, Input, ViewChild, ElementRef } from '@angular/core';
import { Chart } from 'chart.js';
import { ChartJSInitializationService } from '@modules/dashboard/services/chartjs-initialization.service';
import { DashboardTileCountViewModel } from '@modules/api/dashboard-tile-count-view-model.generated';
import { GetChartJSCenterTextPluginService } from '@modules/dashboard/services/get-chartjs-center-text-plugin.service';

@Component({
    selector: 'app-dashboard-gauge-chart',
    templateUrl: './dashboard-gauge-chart.component.html',
    styleUrls: ['./dashboard-gauge-chart.component.scss']
})
export class DashboardGaugeChartComponent implements AfterViewInit {
    @Input()
    public data?: DashboardTileCountViewModel;

    @Input()
    public totalRecords?: number;

    @ViewChild('canvas', { static: true })
    private _canvasElementRef!: ElementRef<HTMLCanvasElement>;

    constructor(
        chartJSInitializationService: ChartJSInitializationService,
        private readonly _getChartJSCenterTextPluginService: GetChartJSCenterTextPluginService) {
        chartJSInitializationService.initializeChartJS();
    }

    public ngAfterViewInit(): void {
        this.createGaugeChart();
    }

    private createGaugeChart(): void {
        if (!this.data) {
            return;
        }

        const totalRecords = this.totalRecords || 0;
        new Chart(this._canvasElementRef.nativeElement, {
            type: "doughnut",
            data: {
                labels: [this.data.itemName || ''],
                datasets: [{
                    label: "doughnut",
                    data: [this.data.itemCount, totalRecords - this.data.itemCount],
                    backgroundColor: ['#' + (this.data.color || '000'), '#e5e5e5'],
                    borderWidth: 1
                }]
            },
            options: {
                responsive: true,
                aspectRatio: 1.5,
                circumference: 360 * 0.75, //Only show 75% of a circle
                rotation: 360 * -0.375, //Start drawing from the bottom-left (top is 0, arcs are drawn clockwise, and 0.375 is half of 0.75)
                cutout: '75%',
                plugins:{
                    legend: {
                        display: true,
                        labels: {
                            boxWidth: 13,
                            font: {
                                size: 14,
                            },
                            color: '#4c5673',
                        },
                        onClick: (e) => e.native?.stopPropagation()
                    },
                    tooltip: {
                        enabled: false
                    },
                }
            },
            plugins: [this._getChartJSCenterTextPluginService.getChartJSCenterTextPlugin<"doughnut">(Math.round((this.data.itemCount / totalRecords * 10000) / 100) + '%', '#4c5673', 60)]
        });
    }
}
